import React from 'react';
import { FlaggedValidations } from '../../../helpers/uploadValidation';
import { downloadFile } from '../../../../../../libs/downloadFile';
import { Customer, Site } from '../../../../../../types';
import { UploadData } from '../../../../../../store/uploadStore';
import { uploadTypeToHuman } from '../../../helpers/uploadType';
import { getValidationError } from './getValidationError';
import { ValidationCheck } from '../../../../../../consts/validationCheck';
import { format as formatWithFns } from 'date-fns';

export const useDownloadValidationIssues = (
  customer: Customer,
  site: Site,
  upload: UploadData,
  flaggedValidations: FlaggedValidations,
) => {
  return (event: React.MouseEvent) => {
    event.preventDefault();

    const date = formatWithFns(new Date(upload.overview.date), 'MMM d yyyy');

    let content = `${customer.name}, ${site.name}, ${date}, ${uploadTypeToHuman(upload.meta.type)}:\r\n\r\n`;

    for (const [validation, data] of Object.entries(flaggedValidations)) {
      const { title, note } = getValidationError(validation as ValidationCheck);
      content += `${data.count} photos: ${title}\r\n${note}\r\n`;

      for (const photo of data.names) {
        content += `- ${photo}\r\n`;
      }

      content += '\r\n\r\n';
    }

    content = content.trim();

    downloadFile(`${site.id} validation issues.txt`, content, 'text/plain');
  };
};
